<template>
  <div class="hamburger-container" @click="toggleSideBar" :style="{color: $store.getters.skin.sidebarTextColor}">
    <i :class="sidebar.collapsed ? 'el-icon-s-unfold': 'el-icon-s-fold'" style="font-weight: 400">
      <span v-if="!sidebar.collapsed">关闭侧边栏</span>
    </i>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: 'Hamburger',
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
    }),
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('doToggleSideBar')
    },
  }
}
</script>

<style scoped lang="less">
@import '../../assets/css/variables.less';

.hamburger-container {
  height: 40px;
  max-height: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #f1f1f1;
  cursor: pointer;

  &:hover {
    color: @sidebarActiveColor;
  }

  i, span {
    font-size: 14px;
    padding: 0 5px;
  }
}
</style>
